import { formatAspect } from "utils/playground/banner";
import { TBannerItem, TIconModule } from "services/page/admin";
import { TBannerItem as BannerItemProps } from "optimus-front/lib/services/banner";
import { LinkTargetType } from "optimus-front/lib/services/playground";
import { multilingualImgDisplay, multilingualLinkDisplay } from "utils/mutil-Language";
import { MWEB_MINWIDTH } from "./constants";
import { genPrmLink } from "utils/url";
import { GetAutoLink } from "utils/browser/litbapp";
import { RuntimeProps } from "views";
import { PrmParams } from "utils/prm";

export const transformBanner = (banner: TBannerItem, spm: PrmParams): BannerItemProps => {
	const { width, height } = banner;

	let link = multilingualLinkDisplay(banner);
	const img = multilingualImgDisplay(banner);
	const imgTwo = multilingualImgDisplay(banner, true);
	link = GetAutoLink(genPrmLink({ floor: spm?.floor, position: spm?.position }, link));

	const nextSize = formatBannerSize({
		width,
		height,
	});
	return {
		link,
		img,
		imgTwo,
		width: nextSize.width.toString(),
		height: nextSize.height.toString(),
	};
};

export const transformBanners = (banners: TBannerItem[], spm: PrmParams): BannerItemProps[] => {
	return banners.map((banner, idx) => {
		return transformBanner(banner, { ...spm, position: (idx + 1) });
	});
};
/**
 * m站底部tab临时用法， 以后都用transformBanners代替
 */
export const transformStickTabBanners = (banners: TIconModule[] = [], spm: PrmParams): any[] => {
	const icons = banners.map((icon: TIconModule) => icon.icon);
	const nextBanners = transformBanners(icons, spm);
	return nextBanners.map((item) => {
		const { img, imgTwo, link, ...others } = item;
		return {
			img: link ? imgTwo : img,
			link,
			...others,
		};
	});
};

export const formatBannerSize = ({
	width,
	height,
}: {
	width: number | string;
	height: number | string;
}) => {
	const bannerWidth = formatAspect(width || "");
	const bannerHeight = formatAspect(height || "");
	const aspectRatio = bannerWidth ? (+bannerHeight / bannerWidth).toFixed(3) : 0;

	return {
		width: Math.max(bannerWidth, MWEB_MINWIDTH),
		height: aspectRatio ? `${(+aspectRatio * 100).toFixed(3)}vw` : "auto",
	};
};
// aspectRatio 高宽比列
export const getCardBannerItemSize = (aspectRatio: string = "") => {
	const ratio = +aspectRatio.replace(/(?:auto|vw)/gi, "");
	if (ratio > 100) {
		return {
			itemWidth: 180,
			itemHeight: ratio ? `${(+ratio * 0.747).toFixed(3)}vw` : "auto",
		};
	}
	return {
		itemWidth: 280,
		itemHeight: ratio ? `${(+ratio * 0.48).toFixed(3)}vw` : "auto",
	};
};

/**
 * 针对ios 外跳问题，临时都处理为 - 取消外跳
 */

export const isLinkHasNewWindow = (runtime: RuntimeProps) => {
	if (runtime.isInApp && !runtime.userAgent?.match(/android/gi)) {
		return LinkTargetType.Self;
	}
	return LinkTargetType.Blank;
};
